module.exports = __webpack_public_path__ + "img/car-stick.bb9d191d.png";